import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const k = {
    versionLabel: "domains.application.components.main-layout.components.about-dialog.about-dialog-i18n.versionLabel",
    appServerVersionLabel: "domains.application.components.main-layout.components.about-dialog.about-dialog-i18n.appServerVersionLabel",
    copyright: "domains.application.components.main-layout.components.about-dialog.about-dialog-i18n.copyright",
    clearCache: "domains.application.components.main-layout.components.about-dialog.about-dialog-i18n.clearCache"
};
export const translations = {
    da: {
        versionLabel: "Version",
        appServerVersionLabel: "App Server Version",
        copyright: "© {{ year }} Epona A/S",
        clearCache: "Nulstil Advosys cache"
    },
    en: {
        versionLabel: "Version",
        appServerVersionLabel: "App Server Version",
        copyright: "© {{ year }} Epona A/S",
        clearCache: "Clear Advosys cache"
    }
};
export const useT = () => {
    const { t, i18n } = useTranslation();
    const localT = useMemo(() => ({
        versionLabel: t(k.versionLabel),
        appServerVersionLabel: t(k.appServerVersionLabel),
        copyright: (year) => t(k.copyright, { year }),
        clearCache: t(k.clearCache)
    }), [i18n.language]);
    return useMemo(() => ({ t: localT, i18n }), [localT, i18n]);
};
